import React from "react";
import StopAllComponent from "../../components/StopAll/StopAll.component";
import IPage from "../../interfaces/page"

const StopAllPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <StopAllComponent></StopAllComponent>;
};

export default StopAllPage;
